import React from "react";
import HeroSectionHistory from './components/HeroSectionHistory';
import MadeInGermanyhistory from './components/MadeInGermanyHistory';
import InfoSection from './components/InfoSection';
import ImageSlider from './components/ImageSlider';
import MadeInGermanyExcellenceSection from './components/MadeInGermanyExcellenceSection';
import AdviserSection from './components/AdviserSection';
import { HelmetProvider } from "react-helmet-async";
// Define props interface for Crafted Excellence
interface CraftedExcellenceProps {
  language?: string; // Optional language prop with default 'en'
}

const MadeInGermanyHistory: React.FC<CraftedExcellenceProps> = ({ language = 'en' }) => {
  return (
    <div className="min-h-screen bg-white">
      <main>
        <HelmetProvider>
        <HeroSectionHistory language={language} />
        <MadeInGermanyhistory language={language} />
        <InfoSection language={language} />
        <ImageSlider language={language} />
        <AdviserSection language={language} />
        <MadeInGermanyExcellenceSection language={language} />
        </HelmetProvider>
      </main>
    </div>
  );
};

export default MadeInGermanyHistory;